export const Availability = {
  AvailableNow: 1,
  Preorder: 3,
  Trunkshow: 5
};
